/**
 * 全局组件注册
 */

import mySearch from '@/components/content/mySearch.vue'
import myTable from '@/components/content/myTable.vue'
import myPagination from '@/components/content/myPagination.vue'
//注册并导出多个组件
const components = {
    install: function (Vue) {
        Vue.component('mySearch', mySearch)
        Vue.component('myTable', myTable)
        Vue.component('myPagination', myPagination)
    }
}

//判断
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

export default components